/**
 * Internal app path from a `next` query param. Rejects protocol-relative and external URLs.
 */
export function safeInternalPath(raw: string | null | undefined, fallback = '/app/chats'): string {
  if (!raw || typeof raw !== 'string') return fallback;
  try {
    const d = decodeURIComponent(raw);
    if (!d.startsWith('/') || d.startsWith('//')) return fallback;
    return d;
  } catch {
    return fallback;
  }
}
